import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Gauge, Zap } from "lucide-react";

const HERO = "https://images.unsplash.com/photo-1585824856765-0cab8940a879?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHxvZmYlMjByb2FkJTIwdHJ1Y2slMjB3aGVlbHN8ZW58MHx8fHwxNzg3ODgwMzMxfDA&ixlib=rb-4.1.0&q=85";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => { if (user) navigate("/dashboard"); }, [user, navigate]);

  return (
    <div className="min-h-[calc(100vh-4rem)] grid lg:grid-cols-2">
      <div className="hidden lg:block relative border-r border-border">
        <img src={HERO} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/70" />
        <div className="relative p-12 h-full flex flex-col justify-end">
          <h2 className="font-heading font-900 text-4xl uppercase tracking-tight leading-tight">Buy & sell wheels<br />that <span className="text-blaze">actually fit</span></h2>
          <p className="text-muted-foreground mt-3 max-w-sm">Sign in to list your setup, save rare-spec searches, and message sellers directly.</p>
        </div>
      </div>

      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-sm text-center">
          <div className="w-14 h-14 bg-blaze rounded-sm flex items-center justify-center mx-auto mb-6"><Gauge className="w-7 h-7 text-white" strokeWidth={2.5} /></div>
          <h1 className="font-heading font-900 text-3xl uppercase tracking-tight">Welcome to Fit<span className="text-blaze">Wise</span></h1>
          <p className="text-sm text-muted-foreground mt-2 mb-8">The structured marketplace for truck wheels & tires.</p>
          <Button data-testid="google-login-btn" onClick={login} className="w-full bg-blaze hover:bg-blaze-hover text-white rounded-sm font-bold h-12 gap-2 hover:-translate-y-0.5 transition-transform">
            <Zap className="w-4 h-4" /> Continue with Google
          </Button>
          <p className="text-xs text-muted-foreground mt-4">By continuing you agree to our marketplace terms.</p>
        </div>
      </div>
    </div>
  );
}
